module.exports = __webpack_public_path__ + "static/media/percentage.101db2cb.svg";